import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { makePostRequest } from "../../../../services/apiHandler";
import * as GrIcons from "react-icons/gr";
import { useWizard } from "react-use-wizard";
import Loader from "../../../../shared/loader/Loader";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import failIcon from "../../../../../assets/images/rating-fail.png";
import successIcon from "../../../../../assets/images/rating-suc.png";

const variants = {
  enter: (direction: number) => {
    return {
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1,
  },
};

function CreditForm({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const { goToStep } = useWizard();
  const [userInfo, setUserInfo] = useState({
    netincome: "",
    totalexpense: "",
    otherobligations: "",
    terms: "",
    employersName: "",
    employerPhysicalLocation: "",
  });

  const q: any = sessionStorage.getItem("quote") || {};

  const quote = JSON.parse(q);

  const [showSucDialog, setShowSucDialog] = useState(false);
  const [showFailDialog, setShowFailDialog] = useState(false);

  const [loading, setLoading] = useState(false);

  const tenantCreds = useSelector((state: any) => state.tenantCreds);

  const SKEY = sessionStorage.getItem("SKEY") || "";

  const u: any = sessionStorage.getItem("userInfo") || {};

  const user = JSON.parse(u);
  const d: any = sessionStorage.getItem("userDocs") || {};

  const doc = JSON.parse(d);

  const saveDetails = () => {
    if (!userInfo.employersName) {
      toast.warning(t("creditForm.employersNameError"));
      document.getElementById("employersName")?.focus();
      return;
    }
    if (!userInfo.netincome) {
      toast.warning(t("creditForm.netIncomeError"));
      document.getElementById("netincome")?.focus();
      return;
    }

    if (!userInfo.employerPhysicalLocation) {
      toast.warning(t("creditForm.employersLocationError"));
      document.getElementById("employerPhysicalLocation")?.focus();
      return;
    }

    if (!userInfo.totalexpense) {
      toast.warning(t("creditForm.expenseError"));
      document.getElementById("totalexpense")?.focus();
      return;
    }

    if (!userInfo.otherobligations) {
      toast.warning(t("creditForm.otherDebtsError"));
      document.getElementById("otherobligations")?.focus();
      return;
    }

    if (!userInfo.terms) {
      toast.warning(t("creditForm.acceptTermsError"));
      return;
    }

    sessionStorage.setItem("creditInfo", JSON.stringify(userInfo));

    getRating();
  };

  const getRating = async () => {
    setLoading(true);

    let data = {
      cover: "travel",
      firstname: user.userName,
      idnumber: doc.idNumber,
      lastname: user.userName,
      netincome: Number(userInfo.netincome),
      otherobligations: Number(userInfo.otherobligations),
      qid: quote._id,
      totalexpense: Number(userInfo.totalexpense),
    };

    const result: IApiResponse = await makePostRequest(
      `${process.env.REACT_APP_CORE_API_URL}/creditrating`,
      {
        ...data,
      },
      {
        SKEY: SKEY,
        ModuleID: `${tenantCreds?.moduleId}`,
        apiKey: `${tenantCreds?.moduleId}`,
      },
    );

    if (result.Status === 200) {
      setLoading(false);
      let cre = result.Payload;
      sessionStorage.setItem("credit_resp", JSON.stringify(cre));
      if (cre.score) {
        showDialog("suc");
      } else {
        showDialog("fail");
      }
    }

    if (result.Status === 543 || result.Status === 401) {
      setLoading(false);
      toast.warning(t("creditForm.sessionExpired"));
      goToStep(3);
    }

    if (result.Status === 501) {
      setLoading(false);
      toast.error(t("creditForm.somethingWentWrong"));
    }

    setLoading(false);
  };

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setUserInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const showDialog = (status: any) => {
    if (status === "suc") {
      setShowSucDialog(true);
    }

    if (status === "fail") {
      setShowFailDialog(true);
    }

    let elem: any = document.getElementById("credit-rting-cont") || "";

    elem.style.filter = "blur(5px)";
    elem.style.background = "rgba(0, 0, 0, 0.05)";
  };

  const hideDialog = (status: any) => {
    if (status === "suc") {
      setShowSucDialog(false);
    }

    if (status === "fail") {
      setShowFailDialog(false);
    }

    let elem: any = document.getElementById("credit-rting-cont") || "";

    elem.style.filter = "none";
    elem.style.background = "none";
  };

  const handlePP = () => {
    hideDialog("suc");
    sessionStorage.setItem("payment-screen", "payment-schedule");
    setCurrentScreen("payment-schedule");
  };

  const handleDirect = () => {
    hideDialog("fail");
  };
  const successDialog = (
    <div className="l-dialog-container">
      <img src={successIcon} alt="later doc" />
      <p className="dialog-p-t mt-3">
        {t("creditForm.verificationSuccessful")}
      </p>
      <p className="dialog-p mt-3">
        {t("creditForm.verificationSuccessfulMsg")}
      </p>
      <div onClick={() => handlePP()} className="mt-4 dialog-proc-btn">
        {t("creditForm.proceedBtn")}
      </div>
      <div onClick={() => hideDialog("suc")} className="mt-3 dialog-canc-btn">
        {t("creditForm.cancelBtn")}
      </div>
    </div>
  );

  const failDialog = (
    <div className="l-dialog-container">
      <img src={failIcon} alt="later doc" />
      <p className="dialog-p-t mt-3">
        {t("creditForm.verificationUnsuccessful")}
      </p>
      <p className="dialog-p mt-3">
        {t("creditForm.verificationUnsuccessfulMsg")}
      </p>
      <div onClick={() => handleDirect()} className="mt-4 dialog-proc-btn">
        {t("creditForm.proceedBtn")}
      </div>
      <div onClick={() => hideDialog("fail")} className="mt-3 dialog-canc-btn">
        {t("creditForm.cancelBtn")}
      </div>
    </div>
  );

  return (
    <div>
      {showSucDialog && successDialog}
      {showFailDialog && failDialog}
      <div id="credit-rting-cont">
        <div className="container">
          <motion.div
            variants={variants}
            initial="enter"
            animate="center"
            exit={{ opacity: 0 }}
          >
            <br />
            <div className="reg-title text-center">
              {t("creditForm.formTitlePrefix")}{" "}
              <span className="span-title">
                {" "}
                {t("creditForm.formTitleSuffix")}
              </span>
            </div>
            <br />
            <div className="ky-inputs-container">
              <div className="ky-inputs-inner-container w-100">
                <div className="ky-input-wrapper">
                  <motion.div
                    animate={{ scale: [-0.7, 1] }}
                    transition={{ duration: 1 }}
                    className="ky-input-container mt-4"
                  >
                    <label
                      className="text-left-label mb-2"
                      htmlFor="employersName"
                    >
                      {t("creditForm.employersName")}
                    </label>
                    <br />
                    <input
                      id="employersName"
                      name="employersName"
                      type="text"
                      onChange={handleInputChange}
                      value={userInfo.employersName}
                      placeholder={t("creditForm.employersNamePlaceholder")}
                    ></input>
                  </motion.div>
                </div>
                <div className="ky-input-wrapper">
                  <motion.div
                    animate={{ scale: [-0.7, 1] }}
                    transition={{ duration: 1 }}
                    className="ky-input-container mt-4"
                  >
                    <label className="text-left-label mb-2" htmlFor="netincome">
                      {t("creditForm.netMonthlyIncome")}{" "}
                    </label>
                    <br />
                    <input
                      id="netincome"
                      name="netincome"
                      type="text"
                      onChange={handleInputChange}
                      value={userInfo.netincome}
                      placeholder={t("creditForm.netMonthlyIncomePlaceholder")}
                    ></input>
                  </motion.div>
                </div>
              </div>

              <div className="ky-inputs-inner-container w-100">
                <div className="ky-input-wrapper">
                  <motion.div
                    animate={{ scale: [-0.7, 1] }}
                    transition={{ duration: 1 }}
                    className="ky-input-container mt-4"
                  >
                    <label
                      className="text-left-label mb-2"
                      htmlFor="employerPhysicalLocation"
                    >
                      {t("creditForm.employersLocation")}
                    </label>
                    <br />
                    <input
                      id="employerPhysicalLocation"
                      name="employerPhysicalLocation"
                      type="text"
                      onChange={handleInputChange}
                      value={userInfo.employerPhysicalLocation}
                      placeholder={t("creditForm.employersLocationPlaceholder")}
                    ></input>
                  </motion.div>
                </div>
                <div className="ky-input-wrapper">
                  <motion.div
                    animate={{ scale: [-0.7, 1] }}
                    transition={{ duration: 1 }}
                    className="ky-input-container mt-4"
                  >
                    <label
                      className="text-left-label mb-2"
                      htmlFor="totalexpense"
                    >
                      {t("creditForm.monthlyExpenses")}
                    </label>
                    <br />
                    <input
                      id="totalexpense"
                      name="totalexpense"
                      type="text"
                      onChange={handleInputChange}
                      value={userInfo.totalexpense}
                      placeholder={t("creditForm.monthlyExpensesPlaceholder")}
                    ></input>
                  </motion.div>
                </div>
              </div>
              <div className="ky-inputs-inner-container w-100">
                <div className="ky-input-wrapper">
                  <motion.div
                    animate={{ scale: [-0.7, 1] }}
                    transition={{ duration: 1 }}
                    className="ky-input-container mt-4"
                  >
                    <label className="text-left-label mb-2" htmlFor="idnumber">
                      {t("creditForm.idNumber")}
                    </label>
                    <br />
                    <input
                      className="id-number-input"
                      disabled
                      id="idnumber"
                      name="idnumber"
                      type="text"
                      onChange={handleInputChange}
                      value={doc.idNumber}
                      placeholder={t("creditForm.idNumberPlaceholder")}
                    ></input>
                  </motion.div>
                </div>
                <div className="ky-input-wrapper">
                  <motion.div
                    animate={{ scale: [-0.7, 1] }}
                    transition={{ duration: 1 }}
                    className="ky-input-container mt-4"
                  >
                    <label
                      className="text-left-label mb-2"
                      htmlFor="otherobligations"
                    >
                      {t("creditForm.otherDebt")}
                    </label>
                    <br />
                    <input
                      id="otherobligations"
                      name="otherobligations"
                      type="text"
                      onChange={handleInputChange}
                      value={userInfo.otherobligations}
                      placeholder={t("creditForm.otherDebtPlaceholder")}
                    ></input>
                  </motion.div>
                </div>
              </div>
              <div className="mt-5 d-flex justify-content-start alig-items-start trustgro">
                <input
                  type="checkbox"
                  id="terms"
                  name="terms"
                  onChange={handleInputChange}
                  value={userInfo.terms}
                />
                <div className="terms-link">
                  <span className="terrms-txt">
                    {t("creditForm.termsPrefix")}{" "}
                    <a
                      target="_blank"
                      href="https://cdn.hillcroftinsurance.com/admin/TrustGro_IPF_Terms_and_Conditions_29112021.pdf"
                    >
                      {t("creditForm.termsLink")}
                    </a>{" "}
                    {t("creditForm.termsSuffix")}
                  </span>
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-5">
                <div className="previous">
                  <span
                    onClick={(e) => {
                      sessionStorage.setItem("payment-screen", "payment-opt");
                      sessionStorage.setItem("payment-plan", "false");
                      setCurrentScreen("payment-opt");
                    }}
                  >
                    <span className="GrIcon me-2">
                      <GrIcons.GrFormPreviousLink />
                    </span>{" "}
                    <span className="previous">{t("creditForm.previous")}</span>
                  </span>
                </div>
                {loading && <Loader />}
                {!loading && (
                  <div onClick={() => saveDetails()}>
                    <button className="next-btn">
                      {" "}
                      <span>
                        {t("creditForm.proceed")}{" "}
                        <span className="GrIcon ms-3">
                          <GrIcons.GrFormNextLink />
                        </span>
                      </span>{" "}
                    </button>
                  </div>
                )}
              </div>
            </div>
            <br />
            <br />
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default CreditForm;
